import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { UserRole } from "@/lib/api/user";
import { SmsLifecyclePage } from "@/components/sms-lifecycle";

const searchSchema = z.object({
  tab: z
    .enum(["cohorts", "settings", "observability"])
    .optional()
    .default("cohorts"),
  cohortId: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/sms-lifecycle/")({
  component: SmsLifecyclePage,
  validateSearch: searchSchema,
  beforeLoad: ({ context }) => {
    if (context.user?.role !== UserRole.SUPERADMIN) {
      throw redirect({ to: "/" });
    }
  },
});
